import {DatePicker, DatePickerProps} from "antd";
import dayjs from "dayjs";
import {useDispatch, useSelector} from "react-redux";
import {rKeeperSelect} from "@entities/rKeeper";
import {logsSelect, setTableParams} from "@entities/logs";
import {AppDispatch} from "@config/store";

const CustomDatePicker = () => {

    const {lastShiftClosed} = useSelector(rKeeperSelect);
    const { tableParams} = useSelector(logsSelect);
    const {filters} = tableParams;
    const dispatch = useDispatch<AppDispatch>();

    const handleDateChange: DatePickerProps['onChange'] = (date: unknown) => {
        const dayjsDate = date as dayjs.Dayjs | null;

        if (dayjsDate) {
            const apiFormatDate = dayjsDate.format('YYYY-MM-DD');
            dispatch(
                setTableParams({
                    ...tableParams,
                    pagination: {
                        ...tableParams.pagination,
                        current: 1,
                    },
                    filters: {
                        ...tableParams.filters,
                        date: dayjsDate ? (apiFormatDate as any) : null,
                    },
                }),
            );
        }
    };

    return (
        <DatePicker
            onChange={handleDateChange}
            format='DD-MM-YYYY'
            value={
                filters.date
                    ? dayjs(filters.date as any, 'YYYY-MM-DD')
                    : lastShiftClosed?.SHIFTDATE
                        ? dayjs(lastShiftClosed.SHIFTDATE, 'YYYY-MM-DD')
                        : null
            }
        />
    )
}

export  default CustomDatePicker